import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { setSoundEnabled as setSoundEnabledGlobal } from '@/lib/sounds'
import type { ContentLevel } from '@/types'

interface SettingsState {
  contentLevel: ContentLevel
  soundEnabled: boolean
  notificationsEnabled: boolean
  darkMode: boolean
  pomodoroWorkMinutes: number
  pomodoroBreakMinutes: number

  // Actions
  setContentLevel: (level: ContentLevel) => void
  setSoundEnabled: (enabled: boolean) => void
  setNotificationsEnabled: (enabled: boolean) => void
  setDarkMode: (enabled: boolean) => void
  setPomodoroSettings: (work: number, breakTime: number) => void
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      contentLevel: 2,
      soundEnabled: true,
      notificationsEnabled: true,
      darkMode: true,
      pomodoroWorkMinutes: 25,
      pomodoroBreakMinutes: 5,

      setContentLevel: (level) => set({ contentLevel: level }),
      setSoundEnabled: (enabled) => {
        setSoundEnabledGlobal(enabled)
        set({ soundEnabled: enabled })
      },
      setNotificationsEnabled: (enabled) => set({ notificationsEnabled: enabled }),
      setDarkMode: (enabled) => set({ darkMode: enabled }),
      setPomodoroSettings: (work, breakTime) => set({
        pomodoroWorkMinutes: work,
        pomodoroBreakMinutes: breakTime
      }),
    }),
    {
      name: 'waifudo-settings',
      onRehydrateStorage: () => (state) => {
        // Sync sound enabled state on app load
        if (state) {
          setSoundEnabledGlobal(state.soundEnabled)
        }
      },
    }
  )
)
